




import { Component, Vue, Prop } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class BoxRoomBooking extends Vue {
  @Prop({ required: true }) public readonly quantity!: number;
  @Prop({ required: true }) public readonly date!: string;
  @Prop({ required: true }) public readonly disabled!: boolean;

  get isSaturday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '6';
  }

  get isMonday() {
    const dayOfWeek = moment(this.date).format('d');
    return dayOfWeek === '1';
  }
}
